const GENERIC_SERVER_ERROR =
  'Došlo je do greške na serveru. Pokušajte ponovo kasnije.';
const CONNECTION_ERROR =
  'Nije moguće povezati se sa serverom. Provjerite vezu i pokušajte ponovo.';

export const getApiErrorStatus = (error) =>
  error && error.response ? error.response.status : undefined;

export const isUnauthorizedError = (error) => getApiErrorStatus(error) === 401;

export const getApiErrorMessage = (
  error,
  { context = 'generic', fallback = GENERIC_SERVER_ERROR } = {},
) => {
  const status = getApiErrorStatus(error);
  const response = error && error.response;
  const responseData = response && response.data;
  const serverMessage =
    responseData && (responseData.error || responseData.message);

  if (!response && error && error.request) {
    return CONNECTION_ERROR;
  }

  if (!response) {
    return fallback;
  }

  if (status === 409) {
    return 'Broj za praćenje je već sačuvan.';
  }

  if (status === 429) {
    return 'Previše zahtjeva za praćenje. Pokušajte ponovo kasnije.';
  }

  if (status === 503 && context === 'savedNumbers') {
    return 'Sačuvani brojevi za praćenje trenutno nisu dostupni.';
  }

  if (status === 503 && context === 'login') {
    return 'Prijava putem Googlea trenutno nije dostupna. Pokušajte ponovo kasnije.';
  }

  if (status >= 500) {
    return GENERIC_SERVER_ERROR;
  }

  if (
    status === 400 &&
    context === 'tracking' &&
    serverMessage === 'Tracking data is not found'
  ) {
    return fallback;
  }

  return serverMessage || fallback;
};
